import { z } from 'zod';

import {
    BlobImageSchema,
    CostEntryTypeSchema,
    DateOnlySchema,
} from '@/api/common/common.models';
import { isoDateString } from '@/lib/zod';

import {
    BaseCostEntryFormModelSchema,
    CostSchema,
    refineCostArrays,
} from '../costs/costs.models';
import { ProjectTaskSchema } from '../projectTasks/projectTasks.models';

// TaskCostEntry schema
export const TaskCostEntrySchema = z.object({
    id: z.string(),
    projectTaskId: z.string(),
    entryType: CostEntryTypeSchema,
    notes: z.string().nullable(),
    date: DateOnlySchema,
    isSnagging: z.boolean(),
    costs: z.array(CostSchema),
    images: z.array(BlobImageSchema),
    dateCreated: isoDateString,
    dateModified: isoDateString,
});

export type TaskCostEntry = z.infer<typeof TaskCostEntrySchema>;

export const TaskCostEntryFormModelSchema = refineCostArrays(
    BaseCostEntryFormModelSchema.extend({
        notes: z
            .string()
            .max(2000, {
                error: 'Notes cannot be longer than 2000 characters',
            })
            .nullable()
            .optional(),
        date: DateOnlySchema,
        isSnagging: z.boolean(),
    }),
);

export type TaskCostEntryFormModel = z.infer<
    typeof TaskCostEntryFormModelSchema
>;

export const TaskCostAggregateSchema = z.object({
    parent: ProjectTaskSchema,
    entries: z.array(TaskCostEntrySchema),
    totalCost: z.number(),
    totalLabourCost: z.number(),
    totalMaterialCost: z.number(),
    totalMiscellaneousCost: z.number(),
    totalHours: z.number(),
    entryCount: z.number(),
    toDateProfitabilityPercentage: z.number().optional(),
});

export type TaskCostAggregate = z.infer<typeof TaskCostAggregateSchema>;
